import { render } from "./WelfareSettings.vue?vue&type=template&id=8ad34148&scoped=true"
import script from "./WelfareSettings.vue?vue&type=script&lang=js"
export * from "./WelfareSettings.vue?vue&type=script&lang=js"

import "./WelfareSettings.vue?vue&type=style&index=0&id=8ad34148&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ad34148"]])

export default __exports__